import React, { useEffect, useState } from 'react'
import SecurityHeaders from '../../context/SecurityHeaders';
import ENDPOINT from '../../context/EndPoint';
import axios from 'axios';
import { AccountCircle, Delete, Edit, MoreVert } from '@material-ui/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Avatar } from '@mui/material';
import SnackbarToast from '../../components/toasts/SnackbarToast';


const UpdateMentor = () => {
    const params = useParams()
    const  dispatch = useDispatch()
    const navigate = useNavigate(); // Changed from navigation to navigate
    const [open, setOpen] = useState({ open: false, message: '', type: '' });

    // State declarations with initial empty values
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [onlineStatus, setOnlineStatus] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [about, setAbout] = useState(''); // Fixed capitalization
    const [bio, setBio] = useState(''); // Fixed capitalization
    const [experience, setExperience] = useState(''); // Fixed capitalization
    const [linkedin, setLinkedin] = useState('');
    const [skillDescription, setSkillDescription] = useState(''); // Fixed naming convention
    const [skillTitle, setSkillTitle] = useState('');
    const [skills, setSkills] = useState('');
    const [status, setStatus] = useState('');
    const [trainsAt, setTrainsAt] = useState(''); // Fixed naming convention
    const [companyLogo, setCompanyLogo] = useState('');
    const [coverImg, setCoverImg] = useState('');
    const [profilePic, setProfilePic] = useState(null); // For file upload
    const [rating, setRating] = useState('');

    // Fetch mentor data
    const getMentor = async () => {
        try {
           const  data = new FormData()
            data.append('mentor_id', params.id);
            const response = await axios.post(`https://siliconmindstechnologies.com/get-mentor.php`,data, SecurityHeaders);
            if (response.data.status === 'success') {
                const mentorData = response.data.mentor;
                // Update all state values when mentor data is received
                setFirstName(mentorData.first_name || '');
                setProfilePic(mentorData.profile_pic || '');
                setLastName(mentorData.last_name || '');
                setOnlineStatus(mentorData.status || '');
                setEmail(mentorData.email || '');
                setPhone(mentorData.phone_num || '');
                setAbout(mentorData.about || '');
                setBio(mentorData.bio || '');
                setExperience(mentorData.experience || '');
                setLinkedin(mentorData.linkedin || '');
                setSkillDescription(mentorData.skill_description || '');
                setSkillTitle(mentorData.skill_title || '');
                setSkills(mentorData.skills || '');
                setStatus(mentorData.status || '');
                setTrainsAt(mentorData.trains_at || '');
                setCompanyLogo(mentorData.company_logo || '');
                setCoverImg(mentorData.cover_img || '');
                setRating(mentorData.rating || '');
            }
        } catch (error) {
            console.error('Error fetching mentor:', error);
        }
    };

    useEffect(() => {
        getMentor();
    }, []);

    const updateRecord = async (e) => {
        dispatch({type:'LOADING'})
        e.preventDefault();
        const data = new FormData();
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (profilePic && profilePic.size > maxSize) {
            setOpen((prev)=>({...prev, open: true, message: 'Image size must be less than 5MB.', type: 'error' }));
            dispatch({ type: "ERROR", payload: "Image size must be less than 5MB." });
           
            return;
        }
       
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
     
        if ( profilePic && !allowedTypes.includes(profilePic.type)) {
            setOpen((prev)=>({...prev, open: true, message: 'Only JPEG, PNG, or JPG images are allowed.', type: 'error' }));
            dispatch({ type: "ERROR", payload: "Only JPEG, PNG, or JPG images are allowed." });

            return;
        }
          
       if(profilePic.type.startsWith("image/")){
        data.append('profile_pic', profilePic);
       }
    
    data.append("mentor_id", params.id || '');
    data.append('first_name', firstName);
    data.append('last_name', lastName);
    data.append('email', email);
    data.append('phone_num', phone);
    data.append('about', about);
    data.append('bio', bio);
    data.append('experience', experience);
    data.append('linkedin', linkedin);
    data.append('skill_description', skillDescription);
    data.append('skill_title', skillTitle);
    data.append('skills', skills);
    data.append('status', status);
    data.append('trains_at', trainsAt);
    data.append('company_logo', companyLogo);
    data.append('cover_img', coverImg);
    data.append('rating', rating);
    data.append('status', onlineStatus || 'active');
        try {
           

            const response = await axios.post(`${ENDPOINT}update-mentor.php`, data, SecurityHeaders);

            if (response.data.status === "success") {
        dispatch({type:'DONE_LOADING'})
                setOpen({ open: true, message: 'Submission updated successfully!', type: 'success' });
                navigate('/mentors');
            } else {
                dispatch({ payload: response.data.message, type: 'ERROR' });
            }
        } catch (error) {
            dispatch({ payload: `Error updating record: ${error.message}`, type: 'ERROR' });
        }
    };
    return (
        <>

<SnackbarToast open={open} handleClose={()=>setOpen((prev)=>({...prev,open:false}))}/>

            <div className="container d-flex justify-content-center">
                <div className="container card col-11 col-lg-9 col-sm-12 col-md-10 p-4 shadow rounded-3">
                    <h2 className='mb-3'>Update Mentor </h2>
                    <form onSubmit={updateRecord}>
                    {
                        profilePic?<div className="mb-3">
                        <Avatar sx={{ width: 76, height: 76 }} src={ profilePic instanceof File
                                    ? URL.createObjectURL(profilePic)
                                    : profilePic} />
                        </div>:<></>
                    }
                    <div className="mb-3">
                            <label htmlFor="firstName" className="form-label"> If you change Profile</label>
                            <input type="file" accept='images/*' className="form-control" onChange={(e) => setProfilePic(e.target.files[0])} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="firstName" className="form-label">First Name</label>
                            <input type="text" className="form-control" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="lastName" className="form-label">Last Name</label>
                            <input type="text" className="form-control" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label">Phone Number</label>
                            <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                        </div>



                        <div className="mb-3">
                            <label htmlFor="about" className="form-label">About</label>
                            <textarea className="form-control" value={about} onChange={(e) => setAbout(e.target.value)} required />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="bio" className="form-label">Bio</label>
                            <textarea className="form-control" value={bio} onChange={(e) => setBio(e.target.value)} required />
                        </div>


                        <div className="mb-3">
                            <label htmlFor="experience" className="form-label">Experience</label>
                            <input type="text" className="form-control" value={experience} onChange={(e) => setExperience(e.target.value)} required />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="linkedin" className="form-label">LinkedIn</label>
                            <input type="text" className="form-control" value={linkedin} onChange={(e) => setLinkedin(e.target.value)} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="skill_description" className="form-label">Skill Description</label>
                            <input type="text" className="form-control" value={skillDescription} onChange={(e) => setSkillDescription(e.target.value)} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="skill_title" className="form-label">Skill Title</label>
                            <input type="text" className="form-control" value={skillTitle} onChange={(e) => setSkillTitle(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="skills" className="form-label">Skills</label>
                            <input type="text" className="form-control" value={skills} onChange={(e) => setSkills(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="status" className="form-label">Status</label>
                            <input type="text" className="form-control" value={status} onChange={(e) => setStatus(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="trains_at" className="form-label">Trains At</label>
                            <input type="text" className="form-control" value={trainsAt} onChange={(e) => setTrainsAt(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="company_logo" className="form-label">Company Logo</label>
                            <input type="text" className="form-control" value={companyLogo} onChange={(e) => setCompanyLogo(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="cover_img" className="form-label">Cover Image</label>
                            <input type="text" className="form-control" value={coverImg} onChange={(e) => setCoverImg(e.target.value)} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="rating" className="form-label">Rating</label>
                            <input type="text" className="form-control" value={rating} onChange={(e) => setRating(e.target.value)} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="onlineStatus" className="form-label">Online Status</label>
                            <input type="text" className="form-control" value={onlineStatus} onChange={(e) => setOnlineStatus(e.target.value)} />
                        </div>
                        <div className='d-flex justify-content-center' >
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>

                    </form>
                </div>
            </div>


        </>
    )
}

export default UpdateMentor
